/* eslint-disable no-restricted-imports */
import {useVirtualizer as useVirtualizerBase} from '@tanstack/react-virtual';

/**
 * A thin wrapper around the `useVirtualizer` hook from `@tanstack/react-virtual`
 * that disables React Compiler's memoization for the hook.
 *
 * It also provides the Spring team with a way to extend and modify the hook's behavior in the future if needed.
 *
 * We are only exporting the `useVirtualizer` hook for now. Any other exports from `@tanstack/react-virtual` should be
 * imported directly from that package.
 *
 * @TODO Once `@tanstack/react-virtual` is updated to support React Compiler, we can remove this wrapper and import
 * the hook directly from that package. We will also want to update packages/tooling/eslint-presets/base.mjs to remove the rule that
 * restricts the import of `useVirtualizer` from `@tanstack/react-virtual`.
 *
 * @see https://github.com/TanStack/virtual/issues/736#issuecomment-2539937829
 */
export const useVirtualizer = (
  ...args: Parameters<typeof useVirtualizerBase>
) => {
  /**
   * We need to explicitly disable React Compiler's memoization for this hook.
   *
   * @see https://github.com/TanStack/virtual/issues/736#issuecomment-2539937829
   */
  'use no memo';
  return {...useVirtualizerBase(...args)};
};
